import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext, Controller, } from 'react-hook-form';
export const FormField = ({ name, required = false, validate, renderError, children, }) => {
    const { control, trigger } = useFormContext();
    const getErrorMessage = (message) => (renderError ? renderError(message) : message);
    if (typeof children !== 'function')
        return null;
    return (_jsx(Controller, { control: control, name: name, rules: { required, validate }, render: ({ field, fieldState }) => {
            var _a;
            return children({
                fieldProps: field,
                state: fieldState,
                error: ((_a = fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) === null || _a === void 0 ? void 0 : _a.message) ? getErrorMessage(fieldState.error.message) : undefined,
                controls: {
                    validate: () => trigger(name),
                },
            });
        } }));
};
